import { styled } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';
import { sizes } from 'src/themes/sizes';

const TextField = styled(MuiTextField)({
  '& .MuiInputBase-root': {
    borderRadius: sizes.radius.sm,
  },
  '& .MuiInputBase-input': {
    height: sizes.field.textField,
    boxSizing: 'border-box',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
});

export default TextField;
